import BaseControlTypeConst from "./BaseControlTypeConst"

export default class CheckBoxTypeConst extends BaseControlTypeConst {

    static BINARY = 'binary'
    static READONLY = 'readonly'
    static REQUIRED = 'required'
    static TABINDEX = 'tabIndex'
}
